import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    // Take over scroll handling from the browser. With the default "auto",
    // the browser restores the previous scroll position on reload / back-forward
    // — which could drop the user at the footer and fight the reset below.
    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }
    }, [])

    useEffect(() => {
        // Use requestAnimationFrame to ensure this runs after the new page layout is calculated
        requestAnimationFrame(() => {
            // Reset window scroll instantly
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            
            // Reset any internal scroll containers
            const scrollContainers = document.querySelectorAll('main, .overflow-y-auto, .overflow-auto');
            scrollContainers.forEach(container => {
                container.scrollTop = 0;
            });
        });
    }, [pathname])

    return null
}

export default ScrollToTop